import {MerchantSDKSettings} from "../merchant/MerchantSDKSettingsStore";
import {StoreClass, StoreObject} from "../../../stem-core/state/Store";
import {StoreEvent, type StoreIdOrNull} from "../../../stem-core/state/State";
import {MerchantSDKResource} from "./MerchantSDKResource";
import {Merchant} from "../MerchantStore";

/* TODO @branch @cleanup Remove this in the future.
    this is required because the ws server does not guarantee the order of
    subscription status updates - ACTIVE status may be received before
    PENDING
*/
export class PaymentStatusDependentStore extends StoreObject {
    static importState(objects: any[]): void {
        objects = objects || [];
        for (const obj of objects) {
            const subscription = this.get(obj.id);
            if (!this.shouldSkipUpdate(subscription, obj)) {
                super.importState([obj]);
            }
        }
    }

    static applyEvent(event: StoreEvent): any {
        const obj = this.getObjectForEvent(event);

        if (this.shouldSkipUpdate(obj, event.data)) {
            event.data = obj;
        }
        return super.applyEvent(event);
    }

    static shouldSkipUpdate(obj: any, updateObj: any): boolean {
        return !updateObj;
    }
}


// Since multiple objects might have been created on a version fork, we'll find the one we edited by the parent id
export function loadVersionedObjectFromResponse<T extends MerchantSDKResource>(store: StoreClass<T>, response: any, expectedParentId: StoreIdOrNull): any {
    const objects = store.load(response);
    if (objects.length <= 1) {
        return objects[0];
    }
    // We forked the published version of merchant settings with this request
    const sdkSettingsVersion = MerchantSDKSettings.loadObject(response);
    // Find the object that is part of the forked settings and has the expected
    // version parent.
    return objects.find(obj => obj.settingsVersion === sdkSettingsVersion && obj.parentId == expectedParentId);
}
